/**
 * List of process statuses
 */
export enum ProcessStatus {
  SCHEDULED,
  RUNNING,
  COMPLETED,
  FAILED
}
